import React, {} from 'react';
import {useSelector} from 'react-redux';

import {applicationSelector} from '../../redux/application'
import {CircularProgress} from '@material-ui/core';


const style = {
  position: 'absolute',
  zIndex: 9999,
  top: '75px',
  right: '2em',
  pointerEvents: 'none',
  opacity: 1
};

export default function DisplayLoader() {
  const {loader} = useSelector(applicationSelector);

  return (
    <CircularProgress size={30} thickness={4} style={loader ? style : {...style, opacity: 0}} />

  );
}

